(function ( $ ) {
    $.fn.openModal = function() {
        return $(this).each(function(){
            var $that = $(this),
                $target = $($that.data('target'));

            $that.on('click', function(e){
                e.stopPropagation();
                if ($('.js-modal-container.is-open').not($target).length) {
                    $('.js-modal-container.is-open').not($target).removeClass('is-open');
                    setTimeout(function(){
                        $target.addClass('is-open');
                    }, 100);
                }
                else {
                    $target.addClass('is-open');
                }
                fixBody();
            });
        });
    };
}( jQuery ));

(function ( $ ) {
    $.fn.closeModal = function() {
        return $(this).each(function(){
            var $that = $(this);

            $that.on('click', function(){
                if ($('.js-modal-container.is-open').length) {
                    var cookieName = 'modal-' + $('.js-modal-container.is-open .js-modal').data('id');
                    Cookies.set(cookieName , '1', { expires: 365 });
                    $('.js-modal-container.is-open').removeClass('is-open');
                    unfixBody();
                }
            });
        });
    };
}( jQuery ));

$(function(){
    if ($('.js-modal').length) {
        $('.js-modal').each(function(){
            if (Cookies.get('modal-' + $(this).data('id')) != 1) {
                $(this).parent().addClass('is-open');
                fixBody();
            }   
        });
    }

    if ($('.js-open-modal').length) {
        $('.js-open-modal').openModal();
    }
    if ($('.js-close-modal').length) {
        $('.js-close-modal').closeModal();
    }

    $body.on('click', function(){
        if ($('.js-modal-container.is-open').length) {
            var cookieName = 'modal-' + $('.js-modal-container.is-open .js-modal').data('id');
            Cookies.set(cookieName , '1', { expires: 365 });
            $('.js-modal-container.is-open').removeClass('is-open');
            unfixBody();
        }
        if ($('.js-lightbox-container.is-open').length) {
            $('.js-lightbox-container').removeClass('is-open');
            unfixBody();
        }
    });
    $(document).on('keydown', function(e){
        if ($('.js-lightbox-container.is-open').length) {
            if (e.keyCode == 37) {
                prevLightboxItem();
            }
            else if (e.keyCode == 39) {
                nextLightboxItem();
            }
            else if (e.keyCode == 27) {
                unfixBody();
                $('.js-lightbox-container').removeClass('is-open');
            }
        }
    });
    $('.js-modal, .js-lightbox').on('click', function(e){
        e.stopPropagation();
    });
    $('.js-item-lightbox').on('click', function(e){
        e.stopPropagation();
        fixBody();
        $('.js-lightbox-container').addClass('is-open');
        lightboxImgs = $(this).parents('.js-items-lightbox').data('images');
        lightboxIndex = $(this).data('index');
        var src = lightboxImgs[lightboxIndex];
        loadLightboxImg(src);
    });
    $('.js-close-lightbox').on('click', function(e){
        unfixBody();
        $('.js-lightbox-container').removeClass('is-open');
    });
    $('.js-next-lightbox').on('click', function(e){
        e.stopPropagation();
        nextLightboxItem();
    });
    $('.js-prev-lightbox').on('click', function(e){
        e.stopPropagation();
        prevLightboxItem();
    });
});

function nextLightboxItem(){
    if (lightboxIndex < lightboxImgs.length - 1 ){
        lightboxIndex++;
    } else {
        lightboxIndex = 0;
    }
    var src = lightboxImgs[lightboxIndex];
    loadLightboxImg(src);
}

function prevLightboxItem(){
    if (lightboxIndex > 0 ){
        lightboxIndex--;
    } else {
        lightboxIndex = lightboxImgs.length - 1;
    }
    var src = lightboxImgs[lightboxIndex];
    loadLightboxImg(src);
}

function loadLightboxImg(src){
    var img = new Image();
    img.src = src;    
    $('.js-lightbox').css('background-image', '').addClass('loading');
    if(src.length){
        $(img).on('load', function(){
            $('.js-lightbox').removeClass('loading');
            $('.js-lightbox').css('background-image', 'url('+src+')');
        });
    }
}